<template lang="html">
  <div>
    <ul class="pagination text-lighter">
      <li :class="{ disable: currentPage === 1 }" @click="go(currentPage - 1)" class="go-btn">
        <img src="/static/launchPreview/arrow-left.png" alt="上一页">
      </li>
      <li :class="{ active: currentPage === 1 }" @click="go(1)">1</li>
      <li v-show="pages[0] > 2">...</li>
      <li v-for="page in pages" :class="{ active: currentPage === page }" @click="go(page)">{{ page }}</li>
      <li v-show="pages[pages.length - 1] < totalPage - 1">...</li>
      <!-- <li :class="{ active : currentPage === totalPage }" @click="go(totalPage)">{{ totalPage }}</li> -->
      <li :class="{ disable: currentPage === totalPage }" @click="go(currentPage + 1)" class="go-btn">
        <img src="/static/launchPreview/arrow-right.png" alt="下一页">
      </li>
      <li v-if="showJump && totalPage > 1" class="page-jump">
        <span>共<em>{{ totalPage }}</em>页，跳转至</span>
        <input type="number" min="1" :max="totalPage" v-model="jumpPage">
        <span>页</span>
        <button @click="go(jumpPage)">确定</button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    totalPage: {
      type: Number,
      default: 1,
      required: true
    },
    showItems: {
      type: Number,
      default: 10
    },
    showPrev: {
      type: Boolean,
      default: true
    },
    showNext: {
      type: Boolean,
      default: true
    },
    showJump: {
      type: Boolean,
      default: false
    },
    initPage: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      currentPage: 0,
      jumpPage: 0,
      modalShow: false
    }
  },
  created () {
    this.currentPage = this.initPage
  },
  computed: {
    pages () {
      const getPages = (start, end) => {
        const pageItem = []
        let i
        if (start <= 1 || start > this.totalPage || start > end) { start = 2 }
        if (end <= 1 || end > this.totalPage || end < start) { end = this.totalPage - 1 }
        for (i = start; i <= end; i++) { pageItem.push(i) }
        return pageItem
      }
      if (this.currentPage <= 5) { return getPages(2, 10) }
    }
  },
  methods: {
    go (page) {
      if (page > 5) {
        this.$emit('alert-tip',
        { head: '温馨提示', content: '<div class="text-center">仅推广用户可见</div>' },
        'alertTip')
        return
      }
      if (page < 1) { page = 1 }
      if (page > this.totalPage) { page = this.totalPage }
      if (page === this.currentPage) { return }
      this.currentPage = parseInt(page, 10)
      this.$emit('go-page', {
        page: this.currentPage
      })
    }
  },
  watch: {
    initPage (newVal, oldVal) {
      this.$set(this, 'currentPage', newVal)
      this.jumpPage = newVal
    }
  }
}
</script>

<style lang="less" scoped>
.pagination {
  list-style: none;
  li {
    display: inline-block;
    margin: 0 5px;
    vertical-align: middle;
    text-align: center;
    cursor: pointer;
    width: 27px;
    height: 27px;
    line-height: 27px;
    border: 1px solid #eee;
    color: #c0c7da;
    background-color: #fff;
    &.active {
      color: #393d48;
      border: 1px solid #393d48;
    }
    &.go-btn {
      width: 56px;
      height: 30px;
      padding: 4px 0;
      img {
        height: 14px;
      }
      &.disable {
        cursor: not-allowed;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// pagination.vue?5362e57c